<script setup lang="ts">
import InformationBaseCardVue from '@/components/Cards/InformationBaseCard.vue'
import { StackLayout } from '@/components/Layouts'
import { TypographyWithPrefix } from '@/components/Typography'
import type { TicketModel } from '@/types/models/TicketModel'

type Props = {
    data?: TicketModel
}
defineProps<Props>()
</script>

<template>
    <InformationBaseCardVue :label="$t('technician.ticket.detail.informationUser')">
        <StackLayout direction="column" isResponsive>
            <TypographyWithPrefix
                :prefix="$t('technician.ticket.detail.nameUser')"
                :label="data?.user?.name"
                boldLabel />
            <TypographyWithPrefix
                :prefix="$t('technician.ticket.detail.mailUser')"
                :label="data?.user?.email"
                boldLabel />
        </StackLayout>
    </InformationBaseCardVue>
</template>
